<template>
  <v-container>
    <v-row
      ><v-col cols="0" lg="0" xl="1"></v-col
      ><v-col cols="12" lg="12" xl="10">
        <v-data-table
          id="storeTable"
          ref="vDataTable"
          v-model="selected"
          :headers="headers"
          :items="dessertsFilter"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search"
          item-key="storeNo"
          show-expand
          :items-per-page="50"
        >
          <template v-slot:top>
            <v-toolbar
              :flat="offsetTop <= 0"
              style="
                position: sticky;
                top: 73px;
                background-color: #fff;
                z-index: 1;
              "
            >
              <v-toolbar-title>商家列表</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog persistent v-model="dialog">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue-grey"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    新增
                  </v-btn>
                  <!-- <v-btn
                    color="blue-grey lighten-1"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2 mr-2"
                    @click="next()"
                  >
                    載入更多
                  </v-btn> -->
                  <v-btn
                    color="blue-grey lighten-1"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mr-2 mt-2"
                    @click="expiredVerification"
                    ><v-icon dark left class="mr-1"> mdi-restore </v-icon>
                    過期驗證
                  </v-btn>
                  <v-btn
                    color="blue-grey lighten-1"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mr-2 mt-2"
                    @click="updateToApp"
                    ><v-icon dark left class="mr-1"> mdi-cellphone </v-icon>
                    更新至APP
                  </v-btn>
                  <v-btn
                    color="blue-grey lighten-2"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2 mr-2"
                    @click="exportExcel()"
                  >
                    匯出 Excel </v-btn
                  ><v-spacer></v-spacer
                  ><v-btn
                    color="blue-grey lighten-2"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2"
                    @click="(actTypesFilter = ''), (expiredFilter = '')"
                  >
                    清除 </v-btn
                  ><v-select
                    v-model="expiredFilter"
                    class="mr-2"
                    style="width: 10px"
                    :items="expireds"
                    label="過期"
                    hide-details="true"
                    persistent-hint
                    dense
                    outlined
                    required
                    single-line
                  ></v-select
                  ><v-select
                    v-model="actTypesFilter"
                    class="mr-2"
                    style="width: 10px"
                    :items="actTypes"
                    item-text="actTypeName"
                    item-value="actTypeId"
                    label="分類"
                    hide-details="true"
                    persistent-hint
                    dense
                    outlined
                    required
                    single-line
                  ></v-select>

                  <!--<v-switch
                    v-model="singleExpand"
                    label="Single expand"
                    class="pa-3"
                  ></v-switch>
                  <v-switch
                    v-model="singleSelect"
                    label="Single select"
                    class="pa-3"
                  ></v-switch>-->
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </template>
                <v-card>
                  <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text class="pt-6">
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                          <!--<v-col cols="12" md="4">
                          <v-text-field
                            v-model="template.storeNo"
                            label="編號"
                            hide-details="true"
                            dense
                            outlined
                            required
                          ></v-text-field> </v-col
                        >--><v-col cols="12" md="2">
                            <!--<v-text-field
                            v-model="template.actType"
                            label="actType"
                            hide-details="true"
                            dense
                            outlined
                            required
                          ></v-text-field>--><v-select
                              v-model="template.actType"
                              :items="actTypes"
                              item-text="actTypeName"
                              item-value="actTypeId"
                              label="*分類"
                              hide-details="true"
                              persistent-hint
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="template.storeName"
                              :counter="10"
                              label="*店名"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-text-field> </v-col
                          ><v-col cols="12" md="4">
                            <v-text-field
                              v-model.trim="template.webSiteUrl"
                              label="*官網"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-checkbox
                              v-model="template.expired"
                              label="過期"
                              class="mt-1"
                              hide-details="true"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="2">
                            <!--<v-text-field
                            v-model="template.city"
                            label="city"
                            hide-details="true"
                            dense
                            outlined
                            required
                          ></v-text-field>-->
                            <v-select
                              v-model="template.city"
                              :items="citys"
                              item-text="cityName"
                              item-value="cityId"
                              label="*縣市"
                              hide-details="true"
                              persistent-hint
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model.trim="template.address"
                              label="*地址"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-text-field
                              v-model.trim="template.phone"
                              label="*電話"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-text-field
                              v-model.number="template.lat"
                              label="*緯度(lat)"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-text-field
                              v-model.number="template.lng"
                              label="*經度(lng)"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-text-field>
                          </v-col>

                          <!--<v-col cols="12" md="4">
                            <v-text-field
                              v-model="template.memo"
                              label="備註"
                              hide-details="true"
                              dense
                              outlined
                            ></v-text-field>
                          </v-col>-->
                          <v-col cols="4" md="2">
                            <v-select
                              v-model="template.storeIsInGroup"
                              :items="storeIsInGroups"
                              label="集團代表"
                              hide-details="true"
                              persistent-hint
                              dense
                              outlined
                            ></v-select>
                          </v-col>
                          <v-col cols="4" md="2">
                            <v-text-field
                              v-model="template.groupId"
                              label="集團代碼"
                              hide-details="true"
                              dense
                              outlined
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-select
                              v-model="template.display"
                              :items="displays"
                              label="*是否顯示"
                              hide-details="true"
                              persistent-hint
                              dense
                              outlined
                              required
                            ></v-select>
                          </v-col>
                          <!--<v-col cols="12" md="4">
                            <v-text-field
                              v-model="template.title"
                              label="*活動名稱"
                              hide-details="true"
                              dense
                              outlined
                              :rules="[(v) => !!v]"
                            ></v-text-field>
                          </v-col>-->
                          <v-col cols="12" md="3">
                            <!--<v-text-field
                            v-model="template.startDate"
                            label="起始日期"
                            hide-details="true"
                            dense
                            outlined
                            required
                          ></v-text-field>-->
                            <v-menu
                              v-model="startTimeMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="template.startDate"
                                  label="*起始日期"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  dense
                                  outlined
                                  hide-details="true"
                                  required
                                  :rules="[(v) => !!v]"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="template.startDate"
                                no-title
                                @input="startTimeMenu = false"
                              ></v-date-picker>
                            </v-menu>
                            <!--<v-menu
                            ref="startTimeMenu"
                            v-model="startTimeMenu"
                            :close-on-content-click="false"
                            :return-value.sync="template.startDate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="template.startDate"
                                label="起始日期"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                dense
                                outlined
                                hide-details="true"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="template.startDate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="startTimeMenu = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.startTimeMenu.save(template.startDate)
                                "
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>-->
                          </v-col>
                          <v-col cols="12" md="3">
                            <!--<v-text-field
                            v-model="template.endDate"
                            label="結束日期"
                            hide-details="true"
                            dense
                            outlined
                            required
                          ></v-text-field>-->
                            <v-menu
                              v-model="endTimeMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="template.endDate"
                                  label="*結束日期"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  dense
                                  outlined
                                  required
                                  hide-details="true"
                                  :disabled="!template.startDate"
                                  :rules="
                                    dateRules(
                                      template.endDate,
                                      template.startDate
                                    )
                                  "
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="template.endDate"
                                no-title
                                @input="endTimeMenu = false"
                              ></v-date-picker>
                            </v-menu>
                            <!--<v-menu
                            ref="endTimeMenu"
                            v-model="endTimeMenu"
                            :close-on-content-click="false"
                            :return-value.sync="template.endDate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="template.endDate"
                                label="結束日期"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                dense
                                outlined
                                hide-details="true"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="template.endDate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="endTimeMenu = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.endTimeMenu.save(template.endDate)
                                "
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>-->
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-textarea
                              v-model="template.title"
                              label="*活動名稱"
                              hide-details="true"
                              dense
                              outlined
                              required
                              rows="3"
                              :rules="[(v) => !!v]"
                            ></v-textarea>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-textarea
                              v-model="template.description"
                              label="*介紹"
                              hide-details="true"
                              dense
                              outlined
                              required
                              rows="3"
                              :rules="[(v) => !!v]"
                            ></v-textarea> </v-col
                          ><v-col cols="12" md="12">
                            <v-textarea
                              v-model="template.memo"
                              label="備註"
                              hide-details="true"
                              dense
                              outlined
                              required
                              rows="3"
                            ></v-textarea>
                          </v-col>
                          <!--<v-col cols="12" md="4">
                          <v-text-field
                            label="已過期"
                            hide-details="true"
                            :value="template.expired"
                            dense
                            outlined
                            required
                          ></v-text-field>
                          <v-select
                            v-model="template.expired"
                            :items="expireds"
                            label="已過期"
                            dense
                            outlined
                          ></v-select>
                        </v-col>-->

                          <!--<v-col cols="12" md="4">
                          <v-checkbox
                            v-model="template.shouldDisplay"
                            label="啟用"
                            class="mt-1"
                            hide-details="true"
                          ></v-checkbox>
                        </v-col>-->
                          <v-col cols="12" md="3">
                            <v-img
                              :lazy-src="
                                template.logoUrl
                                  ? template.logoUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              max-height="90"
                              :src="
                                template.logoUrl
                                  ? template.logoUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="template.logoUrl"
                              class="mb-3"
                              label="商標網址"
                              hide-details="true"
                              dense
                              outlined
                            ></v-text-field>
                            <!--<v-file-input
                            v-model="logoFile"
                            label="File input"
                            class="mt-3"
                            @change="onFileChange"
                            hide-details="true"
                            outlined
                            dense
                            accept="image/png, image/jpeg, image/bmp"
                          ></v-file-input>-->
                            <v-btn
                              depressed
                              color="cyan lighten-1"
                              class="white--text"
                              @click="
                                upLoadingImg = 'logo';
                                showUploadImg();
                              "
                            >
                              上傳商標
                            </v-btn>
                            <v-btn
                              depressed
                              color="grey"
                              class="ml-2 white--text"
                              @click="template.logoUrl = ''"
                            >
                              清除商標
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-img
                              :lazy-src="
                                template.mainPictureUrl
                                  ? template.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              max-height="90"
                              :src="
                                template.mainPictureUrl
                                  ? template.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="template.mainPictureUrl"
                              class="mb-3"
                              label="主圖網址"
                              hide-details="true"
                              dense
                              outlined
                            ></v-text-field>
                            <!--<v-file-input
                            v-model="mainPictureFile"
                            label="File input"
                            class="mt-3"
                            @change="onFileChange"
                            hide-details="true"
                            outlined
                            dense
                            accept="image/png, image/jpeg, image/bmp"
                          ></v-file-input>-->
                            <v-btn
                              depressed
                              color="orange lighten-1"
                              class="white--text"
                              @click="
                                upLoadingImg = 'mainPicture';
                                showUploadImg();
                              "
                            >
                              上傳主圖
                            </v-btn>
                            <v-btn
                              depressed
                              color="grey"
                              class="ml-2 white--text"
                              @click="template.mainPictureUrl = ''"
                            >
                              清除主圖
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-img
                              :lazy-src="
                                template.subPictureUrl
                                  ? template.subPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              max-height="90"
                              :src="
                                template.subPictureUrl
                                  ? template.subPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="template.subPictureUrl"
                              class="mb-3"
                              label="副圖網址"
                              hide-details="true"
                              dense
                              outlined
                            ></v-text-field>
                            <!--<v-file-input
                            v-model="subPictureFile"
                            label="File input"
                            class="mt-3"
                            @change="onFileChange"
                            hide-details="true"
                            outlined
                            dense
                            accept="image/png, image/jpeg, image/bmp"
                          ></v-file-input>-->
                            <v-btn
                              depressed
                              color="orange lighten-1"
                              class="white--text"
                              @click="
                                upLoadingImg = 'subPicture';
                                showUploadImg();
                              "
                            >
                              上傳副圖
                            </v-btn>
                            <v-btn
                              depressed
                              color="grey"
                              class="ml-2 white--text"
                              @click="template.subPictureUrl = ''"
                            >
                              清除副圖
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      取消
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      v-if="editedIndex != -1"
                      @click="saveAs"
                    >
                      另存新檔
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      儲存
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center"
                    >確定要移除
                    <span class="d-inline-block mx-2" style="color: #ff5252"
                      >storeNo.{{ template.storeNo }}</span
                    >
                    ?</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue-grey lighten-1"
                      outlined
                      depressed
                      @click="closeDelete"
                      >取消</v-btn
                    >
                    <v-btn
                      color="blue-grey lighten-1"
                      dark
                      depressed
                      @click="deleteItemConfirm"
                      >確認</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.address`]="{ item }">
            {{ item.address.trim().substr(0, 40) }}
          </template>
          <template v-slot:[`item.actType`]="{ item }">
            {{
              actTypes.filter(function (mapItem, index, array) {
                return mapItem.actTypeId === item.actType;
              })[0]["actTypeName"]
            }}
          </template>
          <template v-slot:[`item.expired`]="{ item }">
            <v-simple-checkbox
              v-model="item.expired"
              :ripple="false"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.actionsEdit`]="{ item }">
            <v-icon @click="editItem(item)" style="font-size: 19px">
              mdi-pencil
            </v-icon>
            <!--<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>-->
          </template>
          <template v-slot:[`item.actionsDel`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template v-slot:[`item.data-table-expand`]="props">
            <v-icon
              :class="{
                'v-data-table__expand-icon': true,
                'v-data-table__expand-icon--active':
                  props.isExpanded && transitioned[getItemId(props.item)],
              }"
              @click="toggleExpand(props)"
            >
              mdi-chevron-down
            </v-icon>
          </template>
          <template v-slot:[`item.display`]="{ item }">
            <v-simple-checkbox
              v-model="item.display"
              class="ml-3"
              :ripple="false"
              disabled
            ></v-simple-checkbox>
          </template>
          <!--展開內容-->
          <template v-slot:[`expanded-item`]="{ headers, item }">
            <td
              :colspan="headers.length"
              :class="{
                'ma-0 pa-0': true,
                'expanded-closing': !transitioned[getItemId(item)],
              }"
              style="height: auto"
            >
              <v-expand-transition>
                <div v-show="transitioned[getItemId(item)]">
                  <div class="pa-2" style="min-height: 100px">
                    <!--<span>{{ item }}</span>-->
                    <v-form>
                      <v-container class="my-6">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-img
                              style="
                                filter: grayscale(0);
                                width: 98%;
                                max-width: 1000px;
                              "
                              :lazy-src="
                                item.mainPictureUrl
                                  ? item.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              :src="
                                item.mainPictureUrl
                                  ? item.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              cover
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="8">
                            <div class="d-flex justify-space-between">
                              <div>
                                <div
                                  class="grey--text text--darken-1 text-subtitle-2 mb-2 font-weight-regular"
                                >
                                  活動日期 {{ item.startDate }} -
                                  {{ item.endDate }}
                                </div>
                                <p
                                  class="text-h4 font-weight-black text--primary mb-1"
                                >
                                  {{ item.storeName }}
                                </p>
                                <div
                                  class="font-weight-black font-weight-medium grey--text text--darken-2 text-h6 mb-10"
                                >
                                  {{
                                    citys.filter(function (
                                      mapItem,
                                      index,
                                      array
                                    ) {
                                      return mapItem.cityId === item.city;
                                    })[0]["cityName"]
                                  }}
                                </div>
                              </div>
                              <div>
                                <v-img
                                  max-width="140"
                                  class="mb-2"
                                  style="opacity: 0.8"
                                  :lazy-src="
                                    item.logoUrl
                                      ? item.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                  :src="
                                    item.logoUrl
                                      ? item.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                ></v-img>
                              </div>
                            </div>
                            <hr
                              class="v-divider theme--light border-dashed mb-4"
                              style="border-style: dashed"
                            />
                            <v-row>
                              <v-col cols="12"
                                ><v-row no-gutters>
                                  <v-col cols="12" md="3">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      編號
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      No.{{ item.storeNo }}
                                    </div></v-col
                                  ><v-col cols="12" md="3">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      分類
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      {{
                                        actTypes.filter(function (
                                          mapItem,
                                          index,
                                          array
                                        ) {
                                          return (
                                            mapItem.actTypeId === item.actType
                                          );
                                        })[0]["actTypeName"]
                                      }}
                                    </div></v-col
                                  >
                                  <v-col cols="12" md="3">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      到期
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      {{ item.expired ? "已到期" : "未到期" }}
                                    </div></v-col
                                  ><v-col cols="12" md="3">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      電話
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      {{ item.phone }}
                                    </div> </v-col
                                  ><v-col cols="12" md="3"
                                    ><p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      起始日期
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2"
                                    >
                                      {{ item.startDate }}
                                    </div></v-col
                                  ><v-col cols="12" md="3"
                                    ><p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      結束日期
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2"
                                    >
                                      {{ item.endDate }}
                                    </div></v-col
                                  ><v-col cols="12" md="3"
                                    ><p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      緯度
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2"
                                    >
                                      {{ item.lat }}
                                    </div></v-col
                                  >
                                  <v-col cols="12" md="3"
                                    ><p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      經度
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2"
                                    >
                                      {{ item.lng }}
                                    </div></v-col
                                  >
                                </v-row>
                              </v-col>
                              <v-col cols="12" md="12" class="py-0">
                                <hr
                                  class="v-divider theme--light border-dashed mb-1"
                                  style="border-style: dashed"
                              /></v-col>
                              <v-col cols="12" md="12">
                                <div v-if="item.title">
                                  <p
                                    class="text-subtitle-2 font-weight-black mb-1"
                                  >
                                    活動名稱
                                  </p>
                                  <div
                                    class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    style="word-break: break-all"
                                  >
                                    {{ item.title }}
                                  </div>
                                </div>
                                <div v-if="item.memo">
                                  <p
                                    class="text-subtitle-2 font-weight-black mb-1"
                                  >
                                    備註
                                  </p>
                                  <div
                                    class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    style="word-break: break-all"
                                  >
                                    {{ item.memo }}
                                  </div>
                                </div>
                                <div>
                                  <p
                                    class="text-subtitle-2 font-weight-black mb-1"
                                  >
                                    地址
                                  </p>
                                  <div
                                    class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    style="word-break: break-all"
                                  >
                                    {{ item.address }}
                                  </div>
                                </div>
                                <div>
                                  <p
                                    class="text-subtitle-2 font-weight-black mb-1"
                                  >
                                    網站
                                  </p>
                                  <div
                                    class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    style="
                                      word-break: break-all;
                                      max-width: 93%;
                                    "
                                  >
                                    {{ item.webSiteUrl }}
                                  </div>
                                </div>

                                <div>
                                  <p
                                    class="text-subtitle-2 font-weight-black mb-1"
                                  >
                                    簡介
                                  </p>
                                  <div
                                    class="text-subtitle-1 grey--text text--darken-2 mb-2"
                                    style="
                                      text-align: justify;
                                      word-break: break-all;
                                      max-width: 93%;
                                    "
                                  >
                                    {{ item.description }}
                                  </div>
                                </div>
                              </v-col>
                            </v-row></v-col
                          >
                        </v-row>
                      </v-container>
                    </v-form>
                  </div>
                </div>
              </v-expand-transition>
            </td>
          </template>
        </v-data-table></v-col
      ><v-col cols="0" lg="0" xl="1"></v-col
    ></v-row>
    <v-dialog
      v-model="dialog_showUploadImg"
      :width="upLoadingImg == 'logo' ? 860 : 860"
    >
      <v-toolbar color="primary" dark>
        <v-toolbar-title>上傳圖片</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog_showUploadImg = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <cropperDialogs
        @update="getImgFile"
        :cropRatio="upLoadingImg == 'logo' ? [1, 1] : [4, 3]"
        :cropWidth="upLoadingImg == 'logo' ? 500 : 600"
        v-if="dialog_showUploadImg"
      ></cropperDialogs>
    </v-dialog>
  </v-container>
</template>

<script>
import ExcelJs from "exceljs";
import cropperDialogs from "@/components/cropperDialogs.vue";
import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import { db, storage } from "@/firebase";
import {
  query,
  where,
  collection,
  getDoc,
  getDocs,
  setDoc,
  doc,
  deleteDoc,
  updateDoc,
  orderBy,
  startAfter,
  limit,
} from "firebase/firestore/lite";

export default {
  components: {
    cropperDialogs,
  },
  data: () => ({
    offsetTop: 0,
    actTypesFilter: "",
    expiredFilter: "",
    valid: true,
    dialog_showUploadImg: false,
    startTimeMenu: false,
    endTimeMenu: false,
    search: "",
    singleSelect: false,
    selected: [],
    expanded: [],
    singleExpand: false,
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "編號", value: "storeNo", width: "8%" },
      {
        text: "商店名稱",
        align: "start",
        sortable: false,
        value: "storeName",
        width: "20%",
      },
      { text: "地址", value: "address", width: "20%" },
      {
        text: "分類",
        value: "actType",
        align: "center",
        width: "7%",
        sortable: false,
      },
      {
        text: "起始日期",
        value: "startDate",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "結束日期",
        value: "endDate",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "過期",
        value: "expired",
        align: "center",
        width: "7%",
      },
      {
        text: "顯示",
        value: "display",
        align: "center",
        width: "7%",
      },
      {
        text: "編輯",
        value: "actionsEdit",
        sortable: false,
        align: "center",
        width: "6%",
      },
      {
        text: "刪除",
        value: "actionsDel",
        sortable: false,
        align: "center",
        width: "6%",
      },
      {
        text: "展開",
        value: "data-table-expand",
        sortable: false,
        align: "center",
        width: "6%",
      },
    ],
    desserts: [],
    citys: [],
    actTypes: [],
    expireds: [true, false],
    storeIsInGroups: [true, false],
    displays: [true, false],
    editedIndex: -1,
    defaultItem: {
      actType: "",
      address: "",
      city: "",
      count: 0,
      createTime: "",
      description: "",
      endDate: "",
      expired: "",
      lat: null,
      lng: null,
      logoUrl: "",
      mainPictureUrl: "",
      memo: "",
      phone: "",
      startDate: "",
      storeName: "",
      storeNo: null,
      subPictureUrl: "",
      title: "",
      webSiteUrl: "",
      groupId: "",
    },
    template: {
      actType: "",
      address: "",
      city: "",
      count: 0,
      createTime: "",
      description: "",
      endDate: "",
      expired: "",
      lat: null,
      lng: null,
      logoUrl: "",
      mainPictureUrl: "",
      memo: "",
      phone: "",
      startDate: "",
      storeName: "",
      storeNo: null,
      subPictureUrl: "",
      title: "",
      webSiteUrl: "",
      groupId: "",
    },
    transitioned: [],
    closeTimeouts: {},
    logoFile: null,
    mainPictureFile: null,
    subPictureFile: null,
    upLoadingImg: "",
    lastVisible: {},
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
    dessertsFilter() {
      let vm = this;
      if (this.expiredFilter && this.actTypesFilter) {
        return this.desserts.filter((item) => {
          return (
            item.expired == vm.expiredFilter &&
            item.actType == vm.actTypesFilter
          );
        });
      } else if (this.expiredFilter) {
        return this.desserts.filter((item) => {
          return item.expired == vm.expiredFilter;
        });
      } else if (this.actTypesFilter) {
        return this.desserts.filter((item) => {
          return item.actType == vm.actTypesFilter;
        });
      } else {
        return this.desserts;
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    singleExpand(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
  },
  async created() {
    this.$bus.$emit("sideBarSelectedItem:push", 3);
    this.template = Object.assign({}, this.defaultItem);
    await this.getCitys();
    await this.getActTypes();
    await this.getStores();
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    showUploadImg() {
      this.dialog_showUploadImg = true;
    },
    getImgFile(file) {
      fetch(file)
        .then((res) => res.blob())
        .then((res) => {
          if (this.upLoadingImg == "logo") {
            this.template.logoUrl = URL.createObjectURL(res);
            this.logoFile = res;
          } else if (this.upLoadingImg == "mainPicture") {
            this.template.mainPictureUrl = URL.createObjectURL(res);
            this.mainPictureFile = res;
          } else if (this.upLoadingImg == "subPicture") {
            this.template.subPictureUrl = URL.createObjectURL(res);
            this.subPictureFile = res;
          }
          this.upLoadingImg = "";
          this.dialog_showUploadImg = false;
        });
    },
    async getCitys() {
      const querySnapshot = await getDocs(collection(db, "city"));
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        this.citys.push(doc.data());
        this.citys.sort((a, b) => {
          return a.cityId - b.cityId;
        });
      });
    },
    async getActTypes() {
      let actTypes = null;
      let myActTypesKey = [];
      const querySnapshot = await getDocs(collection(db, "acttype"));
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data().act);
        actTypes = doc.data().act;
        myActTypesKey = Object.keys(actTypes);
        myActTypesKey.forEach((item) => {
          this.actTypes.push({
            actTypeId: actTypes[item][0],
            actTypeName: actTypes[item][1],
            actTypeUrl: actTypes[item][2],
          });
        });
        this.actTypes.sort((a, b) => {
          return a.actTypeId - b.actTypeId;
        });
      });
    },
    async getAllStores() {
      const querySnapshot = await getDocs(collection(db, "stores"));
      querySnapshot.forEach((doc) => {
        this.desserts.push(doc.data());
        this.desserts.sort((a, b) => {
          return b.storeNo - a.storeNo;
        });
      });
    },
    async getStores() {
      const querySnapshot = await getDocs(collection(db, "stores"));
      querySnapshot.forEach((doc) => {
        this.desserts.push(doc.data());
        this.desserts.sort((a, b) => {
          return b.storeNo - a.storeNo;
        });
      });
      // const first = query(
      //   collection(db, "stores"),
      //   orderBy("createTime", "desc"),
      //   limit(50)
      // );
      // const documentSnapshots = await getDocs(first);
      // documentSnapshots.forEach((doc) => {
      //   let data;
      //   data = JSON.parse(JSON.stringify(doc.data()));
      //   // console.log(doc.id, " => ", doc.data());
      //   this.desserts.push(data);
      // });
      // this.desserts.sort((a, b) => {
      //   return b.storeNo - a.storeNo;
      // });
      // this.lastVisible =
      //   documentSnapshots.docs[documentSnapshots.docs.length - 1];
      // this.isLoading = false;
    },
    async next() {
      if (this.lastVisible) {
        const next = query(
          collection(db, "stores"),
          orderBy("createTime", "desc"),
          startAfter(this.lastVisible),
          limit(1000)
        );

        const documentSnapshots = await getDocs(next);

        if (documentSnapshots.docs.length == 0) {
          this.$snackbar.add(`沒有更多了`, { color: "success" });
          this.lastVisible = "";
        } else if (documentSnapshots.docs.length < 1000) {
          this.lastVisible = "";
        } else {
          this.lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 1];
        }

        documentSnapshots.forEach((doc) => {
          let data;
          data = JSON.parse(JSON.stringify(doc.data()));
          this.desserts.push(data);
        });
        this.desserts.sort((a, b) => {
          return b.storeNo - a.storeNo;
        });
      } else {
        this.$snackbar.add(`沒有更多了`, { color: "success" });
        this.lastVisible = "";
      }
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      const q = query(
        collection(db, "stores"),
        where("storeNo", "==", this.template.storeNo)
      );
      const querySnapshot = await getDocs(q);
      await deleteDoc(doc(db, "stores", querySnapshot._docs[0].id));
      this.$snackbar.add(`刪除成功`, { color: "success" });
      this.desserts = [];
      await this.getAllStores();
      let storeIndexList = [];
      this.desserts.forEach((item) => {
        if (!item.expired) {
          storeIndexList.push({
            description: `${item.title}${item.description}${item.memo}`,
            storeName: item.storeName,
            storeNo: item.storeNo,
            actType: item.actType,
            city: item.city,
            groupId: item.groupId,
          });
        }
      });
      console.log(storeIndexList);
      await setDoc(doc(db, "storeIndexList", "storeIndexList"), {
        indexList: storeIndexList,
      });
      this.closeDelete();
    },
    async updateToApp() {
      let storeIndexList = [];
      this.desserts.forEach((item) => {
        if (!item.expired) {
          storeIndexList.push({
            description: `${item.title}${item.description}${item.memo}`,
            storeName: item.storeName,
            storeNo: item.storeNo,
            actType: item.actType,
            city: item.city,
            groupId: item.groupId,
          });
        }
      });
      console.log(storeIndexList);
      await setDoc(doc(db, "storeIndexList", "storeIndexList"), {
        indexList: storeIndexList,
      });
      this.$snackbar.add(`已更新至APP`, { color: "success" });
    },
    close() {
      this.logoFile = null;
      this.mainPictureFile = null;
      this.subPictureFile = null;
      this.dialog = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    onFileChange(event) {
      let files = event;
      if (JSON.stringify(files) !== "{}") return;
      if (Math.round(files.size, (Math / 1024) * 100) / 1000000 > 5) {
        alert("圖檔尺寸大於5MB，請壓縮後重新上傳");
        return;
      }
      if (this.mainPictureFile && this.dialog) {
        this.template.mainPictureUrl = URL.createObjectURL(
          this.mainPictureFile
        );
      }
      if (this.subPictureFile && this.dialog) {
        this.template.subPictureUrl = URL.createObjectURL(this.subPictureFile);
      }
      if (this.logoFile && this.dialog) {
        this.template.logoUrl = URL.createObjectURL(this.logoFile);
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          const q = query(
            collection(db, "stores"),
            where("storeNo", "==", this.template.storeNo)
          );
          const querySnapshot = await getDocs(q);
          if (this.mainPictureFile) {
            let fileName = `mainPictureFile.${this.getFileExtension(
              this.mainPictureFile.type
            )}`;
            console.log(fileName);
            await uploadBytes(
              ref(storage, `/stores/${querySnapshot._docs[0].id}/${fileName}`),
              this.mainPictureFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(mainPicture)", snapshot);
              await getDownloadURL(
                ref(storage, `/stores/${querySnapshot._docs[0].id}/${fileName}`)
              ).then((url) => {
                console.log(url);
                this.template.mainPictureUrl = url;
              });
            });
          }
          if (this.subPictureFile) {
            let fileName = `subPictureFile.${this.getFileExtension(
              this.subPictureFile.type
            )}`;
            console.log(fileName);
            await uploadBytes(
              ref(storage, `/stores/${querySnapshot._docs[0].id}/${fileName}`),
              this.subPictureFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(subPicture)", snapshot);
              await getDownloadURL(
                ref(storage, `/stores/${querySnapshot._docs[0].id}/${fileName}`)
              ).then((url) => {
                console.log(url);
                this.template.subPictureUrl = url;
              });
            });
          }
          if (this.logoFile) {
            let fileName = `logoFile.${this.getFileExtension(
              this.logoFile.type
            )}`;
            await uploadBytes(
              ref(storage, `/stores/${querySnapshot._docs[0].id}/${fileName}`),
              this.logoFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(logo)", snapshot);
              await getDownloadURL(
                ref(storage, `/stores/${querySnapshot._docs[0].id}/${fileName}`)
              ).then((url) => {
                console.log(url);
                this.template.logoUrl = url;
              });
            });
          }
          if (!this.template.display) {
            this.template.display = false;
          }
          if (!this.template.groupId) {
            this.template.groupId = "";
          }
          if (!this.template.storeIsInGroup) {
            this.template.storeIsInGroup = false;
          }
          if (this.template.storeIsInGroup == true) {
            if (!this.template.groupId) {
              this.template.storeIsInGroup = false;
              this.$snackbar.add(
                `由於未填寫集團代碼，已將集團代表修改為false`,
                { color: "error" }
              );
            }
          }
          if (!this.template.mainPictureUrl) {
            this.template.mainPictureUrl = "";
          }
          if (!this.template.subPictureUrl) {
            this.template.subPictureUrl = "";
          }
          if (!this.template.logoUrl) {
            this.template.logoUrl = "";
          }
          if (!this.template.memo) {
            this.template.memo = "";
          }
          if (!this.template.webSiteUrl) {
            this.template.webSiteUrl = "";
          }
          await setDoc(
            doc(db, "stores", querySnapshot._docs[0].id),
            this.template
          );
        } else {
          let createdId = doc(collection(db, "env")).id;
          if (this.mainPictureFile) {
            let fileName = `mainPictureFile.${this.getFileExtension(
              this.mainPictureFile.type
            )}`;
            console.log(fileName);
            await uploadBytes(
              ref(storage, `/stores/${createdId}/${fileName}`),
              this.mainPictureFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(mainPicture)", snapshot);
              await getDownloadURL(
                ref(storage, `/stores/${createdId}/${fileName}`)
              ).then((url) => {
                console.log(url);
                this.template.mainPictureUrl = url;
              });
            });
          }
          if (this.subPictureFile) {
            let fileName = `subPictureFile.${this.getFileExtension(
              this.subPictureFile.type
            )}`;
            console.log(fileName);
            await uploadBytes(
              ref(storage, `/stores/${createdId}/${fileName}`),
              this.subPictureFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(subPicture)", snapshot);
              await getDownloadURL(
                ref(storage, `/stores/${createdId}/${fileName}`)
              ).then((url) => {
                console.log(url);
                this.template.subPictureUrl = url;
              });
            });
          }
          if (this.logoFile) {
            let fileName = `logoFile.${this.getFileExtension(
              this.logoFile.type
            )}`;
            console.log(fileName);
            await uploadBytes(
              ref(storage, `/stores/${createdId}/${fileName}`),
              this.logoFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(logo)", snapshot);
              await getDownloadURL(
                ref(storage, `/stores/${createdId}/${fileName}`)
              ).then((url) => {
                console.log(url);
                this.template.logoUrl = url;
              });
            });
          }
          if (!this.template.display) {
            this.template.display = false;
          }
          if (!this.template.groupId) {
            this.template.groupId = "";
          }
          if (!this.template.storeIsInGroup) {
            this.template.storeIsInGroup = false;
          }
          if (this.template.storeIsInGroup == true) {
            if (!this.template.groupId) {
              this.template.storeIsInGroup = false;
              this.$snackbar.add(
                `由於未填寫集團代碼，已將集團代表修改為false`,
                { color: "error" }
              );
            }
          }
          if (!this.template.mainPictureUrl) {
            this.template.mainPictureUrl = "";
          }
          if (!this.template.subPictureUrl) {
            this.template.subPictureUrl = "";
          }
          if (!this.template.logoUrl) {
            this.template.logoUrl = "";
          }
          if (!this.template.memo) {
            this.template.memo = "";
          }
          if (!this.template.webSiteUrl) {
            this.template.webSiteUrl = "";
          }
          if (this.desserts.length == 0) {
            this.template.storeNo = 1;
          } else {
            this.template.storeNo = await this.getUpdatedStoreNo();
          }
          this.template.count = 0;
          this.template.createTime = Number(this.timest());
          this.template.expired = false;
          await setDoc(doc(db, "stores", createdId), this.template);
        }
        this.logoFile = null;
        this.mainPictureFile = null;
        this.subPictureFile = null;

        this.desserts = [];
        await this.getAllStores();
        // let storeIndexList = this.desserts.map((item) => {
        //   return {
        //     description: `${item.title}${item.description}${item.memo}`,
        //     storeName: item.storeName,
        //     storeNo: item.storeNo,
        //     actType: item.actType,
        //     city: item.city,
        //   };
        // });
        let storeIndexList = [];
        this.desserts.forEach((item) => {
          if (!item.expired) {
            storeIndexList.push({
              description: `${item.title}${item.description}${item.memo}`,
              storeName: item.storeName,
              storeNo: item.storeNo,
              actType: item.actType,
              city: item.city,
              groupId: item.groupId,
            });
          }
        });
        console.log(storeIndexList);
        await setDoc(doc(db, "storeIndexList", "storeIndexList"), {
          indexList: storeIndexList,
        });
        this.$snackbar.add(`修改完成`, { color: "success" });
        // this.expiredVerification();
        this.close();
      }
    },
    async saveAs() {
      let createdId = doc(collection(db, "env")).id;
      if (this.mainPictureFile) {
        let fileName = `mainPictureFile.${this.getFileExtension(
          this.mainPictureFile.type
        )}`;
        console.log(fileName);
        await uploadBytes(
          ref(storage, `/stores/${createdId}/${fileName}`),
          this.mainPictureFile
        ).then(async (snapshot) => {
          console.log("Uploaded a blob or file!(mainPicture)", snapshot);
          await getDownloadURL(
            ref(storage, `/stores/${createdId}/${fileName}`)
          ).then((url) => {
            console.log(url);
            this.template.mainPictureUrl = url;
          });
        });
      }
      if (this.subPictureFile) {
        let fileName = `subPictureFile.${this.getFileExtension(
          this.subPictureFile.type
        )}`;
        console.log(fileName);
        await uploadBytes(
          ref(storage, `/stores/${createdId}/${fileName}`),
          this.subPictureFile
        ).then(async (snapshot) => {
          console.log("Uploaded a blob or file!(subPicture)", snapshot);
          await getDownloadURL(
            ref(storage, `/stores/${createdId}/${fileName}`)
          ).then((url) => {
            console.log(url);
            this.template.subPictureUrl = url;
          });
        });
      }
      if (this.logoFile) {
        let fileName = `logoFile.${this.getFileExtension(this.logoFile.type)}`;
        console.log(fileName);
        await uploadBytes(
          ref(storage, `/stores/${createdId}/${fileName}`),
          this.logoFile
        ).then(async (snapshot) => {
          console.log("Uploaded a blob or file!(logo)", snapshot);
          await getDownloadURL(
            ref(storage, `/stores/${createdId}/${fileName}`)
          ).then((url) => {
            console.log(url);
            this.template.logoUrl = url;
          });
        });
      }
      if (!this.template.display) {
        this.template.display = false;
      }
      if (!this.template.groupId) {
        this.template.groupId = "";
      }
      if (!this.template.storeIsInGroup) {
        this.template.storeIsInGroup = false;
      }
      if (this.template.storeIsInGroup == true) {
        if (!this.template.groupId) {
          this.template.storeIsInGroup = false;
          this.$snackbar.add(`由於未填寫集團代碼，已將集團代表修改為false`, {
            color: "error",
          });
        }
      }
      if (!this.template.mainPictureUrl) {
        this.template.mainPictureUrl = "";
      }
      if (!this.template.subPictureUrl) {
        this.template.subPictureUrl = "";
      }
      if (!this.template.logoUrl) {
        this.template.logoUrl = "";
      }
      if (!this.template.memo) {
        this.template.memo = "";
      }
      if (!this.template.webSiteUrl) {
        this.template.webSiteUrl = "";
      }
      if (this.desserts.length == 0) {
        this.template.storeNo = 1;
      } else {
        this.template.storeNo = await this.getUpdatedStoreNo();
      }
      this.template.count = 0;
      this.template.createTime = Number(this.timest());
      this.template.expired = false;
      await setDoc(doc(db, "stores", createdId), this.template);

      this.logoFile = null;
      this.mainPictureFile = null;
      this.subPictureFile = null;

      this.desserts = [];
      await this.getAllStores();
      // let storeIndexList = this.desserts.map((item) => {
      //   return {
      //     description: `${item.title}${item.description}${item.memo}`,
      //     storeName: item.storeName,
      //     storeNo: item.storeNo,
      //     actType: item.actType,
      //     city: item.city,
      //   };
      // });
      let storeIndexList = [];
      this.desserts.forEach((item) => {
        if (!item.expired) {
          storeIndexList.push({
            description: `${item.title}${item.description}${item.memo}`,
            storeName: item.storeName,
            storeNo: item.storeNo,
            actType: item.actType,
            city: item.city,
            groupId: item.groupId,
          });
        }
      });
      console.log(storeIndexList);
      await setDoc(doc(db, "storeIndexList", "storeIndexList"), {
        indexList: storeIndexList,
      });
      this.$snackbar.add(`修改完成`, { color: "success" });
      // this.expiredVerification();
      this.close();
    },
    async getUpdatedStoreNo() {
      try {
        // 指定集合和文件 ID
        const docRef = doc(db, "currentStoreNo", "currentStoreNo");
        // 取得文件
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          // 取得 currentStoreNo 的值，轉為數字並加一
          const currentStoreNoStr = docSnap.data().currentStoreNo;
          const currentStoreNo = parseInt(currentStoreNoStr, 10);
          const updatedStoreNo = currentStoreNo + 1;
          // 將更新後的值存回文件
          await updateDoc(docRef, {
            currentStoreNo: updatedStoreNo.toString(),
          });
          // console.log("更新後的 currentStoreNo:", updatedStoreNo);
          return updatedStoreNo.toString();
        }
      } catch (error) {
        console.error("Error updating document: ", error);
      }
    },
    getFileExtension(filename) {
      return filename.slice(((filename.lastIndexOf("/") - 1) >>> 0) + 2);
    },
    getItemId(item) {
      return item.storeNo; // Must be uid of record (would be nice if v-data-table exposed a "getItemKey" method)
    },
    toggleExpand(props) {
      const item = props.item;
      const id = this.getItemId(item);
      if (props.isExpanded && this.transitioned[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpand(item);
      } else {
        // If we're closed or in the process of closing, expand
        // Stop us from closing if a close transition was started
        clearTimeout(this.closeTimeouts[id]);
        // Tell v-data-table to add the expansion content for the item
        props.expand(true);
        // Show expansion content with transition animation after it's had time to get added to the DOM
        this.$nextTick(() => this.$set(this.transitioned, id, true));
        // Hide all other expanded items if single-expand
        if (this.singleExpand)
          this.$nextTick(() =>
            this.expanded.forEach((i) => i !== item && this.closeExpand(i))
          );
      }
    },
    closeExpand(item) {
      const id = this.getItemId(item);
      // Mark that this item is in the process of closing
      this.$set(this.transitioned, id, false);
      // Remove expansion content from DOM after transition animation has had enough time to finish
      this.closeTimeouts[id] = setTimeout(
        () => this.$refs.vDataTable.expand(item, false),
        600
      );
    },
    timest() {
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);
      return tmp;
    },
    async expiredVerification() {
      const querySnapshot = await getDocs(collection(db, "stores"));
      this.desserts = [];
      querySnapshot.forEach((doc) => {
        let data;
        data = JSON.parse(JSON.stringify(doc.data()));
        data.id = doc.id;
        this.desserts.push(data);
        this.desserts.sort((a, b) => {
          return a.storeNo - b.storeNo;
        });
      });
      await Promise.all(
        this.desserts.map(async (item) => {
          // console.log(res.id, " => ", res.data());
          let nowDateTimestamp = Date.now();
          let endDate = item.endDate;
          let endDateConverter = endDate.split("-");
          let endDateTimestamp = new Date(
            endDateConverter[0],
            endDateConverter[1] - 1,
            endDateConverter[2],
            23,
            59,
            59
          );
          if (
            Number(endDateTimestamp.getTime().toString()) < nowDateTimestamp
          ) {
            let q = query(
              collection(db, "favorites"),
              where("storeNo", "==", item.storeNo.toString())
            );
            let favoritesQuerySnapshot = await getDocs(q);
            if (favoritesQuerySnapshot._docs[0]) {
              // console.log(favoritesQuerySnapshot._docs[0].id);
              await deleteDoc(
                doc(db, "favorites", favoritesQuerySnapshot._docs[0].id)
              );
            }
            let storesRef = doc(db, "stores", item.id);
            return updateDoc(storesRef, {
              expired: true,
            });
          } else {
            if (item.expired == true) {
              let storesRef = doc(db, "stores", item.id);
              return updateDoc(storesRef, {
                expired: false,
              });
            }
          }
        })
      );
      this.$snackbar.add(`驗證完成`, { color: "success" });
      this.desserts = [];
      this.getAllStores();
    },
    dateRules(endDate, startDate) {
      let array = [];
      array[0] = endDate ? true : "結束日期為必填項目";
      array[1] =
        Math.floor(new Date(endDate).getTime() / 1000) >
        Math.floor(new Date(startDate).getTime() / 1000)
          ? true
          : "結束日期必須大於起始日期";
      return array;
    },
    handleScroll() {
      // console.log(
      //   window.scrollY,
      //   window.screen.height,
      //   document.body.scrollHeight
      // );
      this.offsetTop = window.scrollY;
    },
    exportExcel() {
      const workbook = new ExcelJs.Workbook(); // 創建試算表檔案
      const sheet = workbook.addWorksheet("票券列表"); //在檔案中新增工作表 參數放自訂名稱
      sheet.getColumn(1).width = 5;
      sheet.getColumn(2).width = 13;
      sheet.getColumn(3).width = 33;
      sheet.getColumn(4).width = 13;
      sheet.getColumn(5).width = 23;
      sheet.getColumn(6).width = 13;
      sheet.getColumn(7).width = 13;
      sheet.getColumn(8).width = 3;
      sheet.getColumn(9).width = 13;
      sheet.getColumn(10).width = 33;
      sheet.getColumn(12).width = 9;
      sheet.getColumn(13).width = 9;
      sheet.getColumn(14).width = 7;
      sheet.getColumn(15).width = 7;
      let data = [];
      this.desserts.forEach(function (item) {
        data.push([
          item.storeNo,
          item.storeName,
          item.address,
          item.phone,
          item.webSiteUrl,
          item.lat,
          item.lng,
          item.actType,
          item.title,
          item.description,
          item.startDate,
          item.endDate,
          item.expired,
          item.display,
        ]);
      });
      sheet.addTable({
        // 在工作表裡面指定位置、格式並用columsn與rows屬性填寫內容
        name: "table名稱", // 表格內看不到的，算是key值，讓你之後想要針對這個table去做額外設定的時候，可以指定到這個table
        ref: "A1", // 從A1開始
        columns: [
          { name: "編號", defaultColWidth: 10 },
          { name: "商店名稱", defaultColWidth: 100 },
          { name: "地址" },
          { name: "電話" },
          { name: "網址" },
          { name: "緯度" },
          { name: "經度" },
          { name: "分類" },
          { name: "活動名稱" },
          { name: "簡介" },
          { name: "起始日期" },
          { name: "結束日期" },
          { name: "是否過期" },
          { name: "是否顯示" },
        ],
        rows: data,
      });

      // 表格裡面的資料都填寫完成之後，訂出下載的callback function
      // 異步的等待他處理完之後，創建url與連結，觸發下載
      workbook.xlsx.writeBuffer().then((content) => {
        const link = document.createElement("a");
        const blobData = new Blob([content], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });
        link.download = `統一企業集團特約商店 ${this.formatDate(
          new Date()
        )}.xlsx`;
        link.href = URL.createObjectURL(blobData);
        link.click();
      });
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
  },
};
</script>
